export const columns = [
  { id: 'type', label: 'TIPO', minWidth: 45, width: '7%', textAlign: 'center' },
  { id: 'name', label: 'NOME', minWidth: 120, width: '19%' },
  { id: 'uf', label: 'UF', minWidth: 25, width: '5%', textAlign: 'center' },
  { id: 'eventDate', label: 'DATA DO EVENTO', minWidth: 85, width: '14%' },
  { id: 'redeemStart', label: 'RESGATE INÍCIO', minWidth: 70, width: '12%' },
  { id: 'redeemEnd', label: 'RESGATE FIM', minWidth: 70, width: '12%' },
  { id: 'tickets', label: 'INGRESSOS', minWidth: 75, width: '15%' },
  { id: 'points', label: 'PONTOS', minWidth: 35, width: '6%', textAlign: 'center' },
  { id: 'status', label: 'SITUAÇÃO', minWidth: 60, width: '8%' },
  { id: 'edit', label: 'EDITAR', minWidth: 30, width: '2%', textAlign: 'center' }
]
